import { ROUTE_NAME } from '@/shared/constants/routing';

export const STORAGE_EXPIRED = '12h';
export const IDLE_TIME = 1800000; // 30 mins
export const EMBEDDED_IDLE_TIME = 2700000; // 45 mins
export const GREETING_MAX_LENGTH = 30;

export const PS_DEFAULT_OPTIONS = {
  suppressScrollX: true
};

export const PS_TABLE_OPTIONS = {
  suppressScrollY: true
};

export const AMOUNT_INSURED_FORMAT = '0,0';
export const AMOUNT_DEFAULT_FORMAT = '0,0.00';
export const PERCENTAGE_FORMAT = '0.0';

export const SHOW_BANNER_PAGE_LIST = [
  ROUTE_NAME.SELECT_REFERRAL_TYPE,
  ROUTE_NAME.CREATE_LEAD,
  ROUTE_NAME.INTRODUCER
];

export const INSURER_TYPE = [
  {
    name: 'Axa',
    image: 'axa',
    onPanelUntil: null
  },
  {
    name: 'Highway Insurance Company Limited',
    image: 'allianz',
    onPanelUntil: null
  },
  {
    name: 'RSA',
    image: 'rsa',
    onPanelUntil: null
  },
  {
    name: 'Zurich',
    image: 'zurich',
    onPanelUntil: '2023-12-28'
  },
  {
    name: 'Integra',
    image: 'integra',
    onPanelUntil: null
  },
  {
    name: 'UKG',
    image: 'ukg',
    onPanelUntil: '2024-09-01'
  },
  {
    name: 'Bspoke',
    image: 'bspoke',
    onPanelUntil: '2025-04-30'
  },
  {
    name: 'Phoenix MGA',
    image: 'ageas',
    onPanelUntil: null
  },
  {
    name: 'Tradex',
    image: 'tradex',
    onPanelUntil: null
  },
  {
    name: 'Arkel',
    image: 'arkel',
    onPanelUntil: null
  }
];

// API stuff - Cover and Payment
export const INCLUDED = 'Included';
export const EXCLUDED = 'Excluded';
export const NOTAPPLICABLE = 'NotApplicable';
export const ANNUAL = 'Annual';
export const MONTHLY = 'Monthly';
export const MONTHLY_3_MONTHS_DEFERRED = 'Monthly3MonthsDeferred';
export const MONTHLY_2_MONTHS_FREE = 'Monthly2MonthsFree';
export const DIRECTDEBIT = 'DirectDebit';
export const UNKNOWN_INSURER = 'UnknownInsurer';
